module.exports = __webpack_public_path__ + "img/solution--simplify-caregiver-procedures.6c679a19.jpg";